<mat-button-toggle
  [checked]="isInSplitView$ | async"
  (click)="toggleSplitView()"
  class="toolbar-button"
  [matTooltip]="tooltipText$ | async"
>
  <mat-icon [h3CustomIcon]="splitViewIcon"></mat-icon>
</mat-button-toggle>
